angular
    .module('AutoPrequal')
    .controller('errorCtrl', errorCtrl);

errorCtrl.$inject = ['$scope', '$rootScope', '$state', 'SessionFactory', 'DataFactory', 'ErrorFactory', '$timeout'];

function errorCtrl($scope, $rootScope, $state, SessionFactory, DataFactory, ErrorFactory, $timeout) {
    SessionFactory.deleteCurrentSession();

    if (!$rootScope.isLoaded || !ErrorFactory.error || !ErrorFactory.error.code) {
        $rootScope.currentStep = "welcome";
        $state.go('main', { 'hash': 'welcome' });
        return;
        //location.reload()
    }

    $rootScope.progressCurrent = 0;
    $rootScope.progressMobCurrent = 0;
    $rootScope.currentStep = 'error';
    $scope.error = ErrorFactory.error;
	$scope.content = DataFactory.appData.content.error;
	if (ErrorFactory.error.code.indexOf("OOW") > -1) {
		$scope.title = $rootScope.glContent.errors.attempt_err_msg;
		$scope.msg = "";
		jQuery("h1.notice-fail").removeClass("h3").addClass("h4");
	}
    else if (ErrorFactory.error.code != "STO") {
        $scope.title = $scope.content.attention;
        $scope.msg = $scope.error.custom ? $scope.error.desc : $scope.content.generic_msg;
    } else {
		$scope.title = $scope.content.attention;
		$scope.msg = $scope.content.timeout;
    }
    $rootScope.forcedLoader = false;
    $timeout(function () {
        //focus on title after animation is done
        $('.notice.fail')[0].focus();
    }, 600)


    var unlisten = $scope.$on('$locationChangeStart', function (event, next, current) {
        if (!next || next.indexOf('error') === -1) {
            event && event.preventDefault();
            $rootScope.restart();
            unlisten();
        }
    });

    $scope.goBack = function () {
        $rootScope.restart();
    }
}
